import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { AppComponent } from './app.component';
import { MapComponent } from './map/map.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { SearchResultComponent } from "./map/search-result/search-result.component";
import { AppLoadService } from './services/app-load.service';
import { ShowFeatureDataComponent } from './map/query-views/show-feature-data/show-feature-data.component';
import { MapToolsComponent } from './map/map-tools/map-tools.component';
import { FilterPipe } from './map/filter.pipe';
import { CoordinatesComponent } from './map/coordinates/coordinates.component';
import { ShowStationDataComponent } from './map/query-views/show-station-data/show-station-data.component';
import { UploadGeoFilesComponent } from './upload-geo-files/upload-geo-files.component';
import { BnNgIdleService } from "bn-ng-idle";
import { AddLayerComponent } from './add-layer/add-layer.component';
import { UserLayerFilterPipe } from './add-layer/user-layer-filter.pipe';
import { StatusMessageComponent } from './add-layer/status-message/status-message';
import { SwitchApplicationComponent } from './switch-application/switch-application.component';
import { DashComponent } from './dash/dash.component';
import { FooterComponent } from './footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { LoginPromptComponent } from './login-prompt/login-prompt.component';
import { ShowExternalDataComponent } from './map/query-views/show-external-data/show-external-data.component';
import { AboutComponent } from './main-nav/about/about.component';
import { SharedModule } from './shared/shared.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EditFeatureDataComponent } from './map/query-views/edit-feature-data/edit-feature-data.component';
import { LayerFilterComponent } from './main-nav/layer-filter/layer-filter.component';
import { CreateComponent } from './map/create/create.component';
import { EditUserProfileComponent } from './main-nav/edit-user-profile/edit-user-profile.component';
import { MatRadioModule } from '@angular/material/radio';
import { LayerListComponent } from './main-nav/layer-list/layer-list.component';
import { ShowSingleImageComponent } from "./shared/show-single-image/show-single-image.component"
import { MainActionViewComponent } from './main-action-view/main-action-view.component';
import { ContentDeciderComponent } from './map/query-views/content-decider/content-decider.component';
import { LegendBarComponent } from './map/legend-bar/legend-bar.component';
import { ScalarLegendComponent } from './map/scalar-legend/scalar-legend.component';
import { IMAGE_CONFIG } from '@angular/common';

@NgModule({ 
    declarations: [
        AppComponent,
        MapComponent,
        MainNavComponent,
        ShowFeatureDataComponent,
        MapToolsComponent,
        FilterPipe,
        CoordinatesComponent,
        ShowStationDataComponent,
        UploadGeoFilesComponent,
        AddLayerComponent,
        UserLayerFilterPipe,
        StatusMessageComponent,
        SwitchApplicationComponent,
        DashComponent,
        FooterComponent,
        LoginPromptComponent,
        ShowExternalDataComponent,
        AboutComponent,
        CreateComponent,
        EditUserProfileComponent
    ],
    exports: [ShowStationDataComponent], //To use a module-component in another standalone component, it needs to be exported here and in standalone import the AppModule
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], 
    imports: [
        SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        MatRadioModule,
        ShowSingleImageComponent,
        SearchResultComponent,
        ContentDeciderComponent,
        EditFeatureDataComponent,
        LegendBarComponent,
        ScalarLegendComponent,
        MainActionViewComponent,
        LayerFilterComponent,
        LayerListComponent,
        ToastrModule.forRoot({
            preventDuplicates: true,    // Block duplicate messages.
            maxOpened: 1,               // Max toasts opened. Toasts will be queued. 0 is unlimited.
            autoDismiss: true,          // Dismiss current toast when max is reached.
        }),
    ], 
    providers: [
        Title,
        BnNgIdleService,
        //{ provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
        //Changes locale for mat-datePicker modules, en-GB ensures the order is day-month-year instead of month-day-year
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        {
            provide: APP_INITIALIZER,
            useFactory: init_app,
            deps: [AppLoadService],
            multi: true
        },
        {
            provide: IMAGE_CONFIG,
            useValue: {
                disableImageSizeWarning: true,
                disableImageLazyLoadWarning: true
            }
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
    constructor(private matIconRegistrery: MatIconRegistry) {
        //Necessary for using the new Material Symbols font. This way we can use <mat-icon> like before with no change.
        this.matIconRegistrery.setDefaultFontSetClass("material-symbols-outlined")
    }
}

export function init_app( appLoadService: AppLoadService ) {
  return() => appLoadService.initializeApp();
}
